export var EncounterNodeType;
(function (EncounterNodeType) {
    EncounterNodeType["TEXT"] = "text";
    EncounterNodeType["COMBAT"] = "combat";
})(EncounterNodeType || (EncounterNodeType = {}));
export var EncounterCheckEvent;
(function (EncounterCheckEvent) {
    EncounterCheckEvent["ENTER_HEX"] = "enter-hex";
    EncounterCheckEvent["CAMP"] = "camp";
})(EncounterCheckEvent || (EncounterCheckEvent = {}));
// Encounter types
export var EncounterType;
(function (EncounterType) {
    EncounterType["RANDOM"] = "random";
    EncounterType["NPC"] = "npc";
    EncounterType["QUEST"] = "quest";
    EncounterType["DISCOVERY"] = "discovery";
})(EncounterType || (EncounterType = {}));
